// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"ce4d9b35","324":"7d796a72"}[chunkId] + ".chunk.css";
};